<template>
  <div class="row">
    <div class="col-xxl-7">
      <WhatHappening />
    </div>
    <div class="col-xxl-5">
      <div class="row">
        <div class="col-lg-6 col-md-6">
          <ResolveComplaints />
        </div>
        <div class="col-lg-6 col-md-6">
          <AverageSpeedOfAnswer />
        </div>
      </div>
    </div>
    <div class="col-xxl-6">
      <TicketsChart />
    </div>
    <div class="col-xxl-6">
      <NumberOfTickets />
    </div>
    <div class="col-xxl-3">
      <TopPerformerHelpAgent />
    </div>
    <div class="col-xxl-6">
      <UnresolvedTicketsByPriority />
    </div>
    <div class="col-xxl-3">
      <CustomerSatisfaction />
    </div>
    <div class="col-xxl-8">
      <UnsolvedTickets />
    </div>
    <div class="col-xxl-4">
      <ToDoList />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import WhatHappening from "../../template-components/Dashboard/SupportDesk/WhatHappening.vue";
import ResolveComplaints from "../../template-components/Dashboard/SupportDesk/ResolveComplaints.vue";
import AverageSpeedOfAnswer from "../../template-components/Dashboard/SupportDesk/AverageSpeedOfAnswer.vue";
import TicketsChart from "../../template-components/Dashboard/SupportDesk/TicketsChart/index.vue";
import NumberOfTickets from "../../template-components/Dashboard/SupportDesk/NumberOfTickets.vue";
import TopPerformerHelpAgent from "../../template-components/Dashboard/SupportDesk/TopPerformerHelpAgent/index.vue";
import UnresolvedTicketsByPriority from "../../template-components/Dashboard/SupportDesk/UnresolvedTicketsByPriority.vue";
import CustomerSatisfaction from "../../template-components/Dashboard/SupportDesk/CustomerSatisfaction.vue";
import UnsolvedTickets from "../../template-components/Dashboard/SupportDesk/UnsolvedTickets.vue";
import ToDoList from "../../template-components/Dashboard/SupportDesk/ToDoList/index.vue";

export default defineComponent({
  name: "SupportDeskPage",
  components: {
    WhatHappening,
    ResolveComplaints,
    AverageSpeedOfAnswer,
    TicketsChart,
    NumberOfTickets,
    TopPerformerHelpAgent,
    UnresolvedTicketsByPriority,
    CustomerSatisfaction,
    UnsolvedTickets,
    ToDoList,
  },
});
</script>